// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"6296883c","292":"863fb062","381":"f10e3874","467":"f32da0dd","478":"a405a802","501":"27d95e61","767":"42844560"}[chunkId] + ".chunk.css";
};